import React from 'react'
import { ScoreUtil } from 'utils/scoreUtil';
import clsx from 'clsx';
// import style from './style.module.scss';
import style from '../style.module.scss';

const BaseballViewRegular = ({
  overPeriod,
  inningArr,
  special,
  tracker,
  period,
  sortedAwayScores,
  sortedHomeScores,
  isOverView,
  onClickPrev,
  onClickNext,
  awayTotalScore,
  homeTotalScore,
  home,
  away
}) => {
  const _OVER_PIXEL = 25;

  return (
    <>
      <div className={style.regular}>
        <div className={style.inner}>
          <div
            className={style.box}
            style={{ left: -(overPeriod * _OVER_PIXEL) }}
          >
            {inningArr.map((inning, idx) => {
              const specialClass = ScoreUtil.getBaseballSpecaillHSB(
                special,
                inning
              );

              return (
                <dl
                  className={clsx(
                    style.item,
                    tracker.status === 'progress' &&
                      period === inning &&
                      style.on
                  )}
                  key={`box-item-${idx}`}
                >
                  <dt>{inning}</dt>
                  <dd
                    className={clsx(
                      specialClass.away.h && style.h,
                      specialClass.away.s && style.s,
                      specialClass.away.b && style.b
                    )}
                  >
                    {!!sortedAwayScores[idx] && sortedAwayScores[idx].score}
                  </dd>
                  <dd
                    className={clsx(
                      specialClass.home.h && style.h,
                      specialClass.home.s && style.s,
                      specialClass.home.b && style.b
                    )}
                  >
                    {!!sortedHomeScores[idx] && sortedHomeScores[idx].score}
                  </dd>
                </dl>
              );
            })}
          </div>
        </div>
        {isOverView && (
          <div className={style.btn_more}>
            <button
              className={clsx(style.btn, style.btn_prev)}
              onClick={onClickPrev}
            >
              더보기
            </button>
            <button
              className={clsx(style.btn, style.btn_next)}
              onClick={onClickNext}
            >
              더보기
            </button>
          </div>
        )}
      </div>
      <dl className={style.item}>
        <dt>R</dt>
        <dd>{awayTotalScore}</dd>
        <dd>{homeTotalScore}</dd>
      </dl>
      <dl className={style.item}>
        <dt>H</dt>
        <dd>{away.hitCount}</dd>
        <dd>{home.hitCount}</dd>
      </dl>
      <dl className={style.item}>
        <dt>E</dt>
        <dd>{away.errorCount}</dd>
        <dd>{home.errorCount}</dd>
      </dl>
      <dl className={style.item}>
        <dt>B</dt>
        <dd>{away.baseOnBallCount}</dd>
        <dd>{home.baseOnBallCount}</dd>
      </dl>
    </>
  );
};

export default BaseballViewRegular;
